export const encodeEmail = (email) => {
    if (!email || email.trim() === "") {
        throw new Error("Email cannot be null or empty");
    }

    let encoded = "";
    email = email.toLowerCase().trim();

    if (!email.includes("@") || email.indexOf("@") !== email.lastIndexOf("@")) {
        throw new Error("Invalid email format: must contain exactly one @");
    }

    for (let i = 0; i < email.length; i++) {
        const ch = email[i];
        const charCode = ch.charCodeAt(0);

        if (charCode >= 97 && charCode <= 122) {
            encoded += String(charCode - 96).padStart(2, "0");
        } else if (charCode >= 48 && charCode <= 57) {
            encoded += String(30 + (charCode - 48)).padStart(2, "0");
        } else if (ch === ".") {
            encoded += "00";
        } else if (ch === "@") {
            encoded += "27";
        } else if (ch === "-") {
            encoded += "28";
        } else if (ch === "_") {
            encoded += "29";
        } else if (ch === "+") {
            encoded += "40";
        } else {
            throw new Error(`Unsupported character: '${ch}' (ASCII: ${charCode})`);
        }
    }

    return encoded;
};

export const decodeEmail = (encoded) => {
    if (!encoded || encoded.trim() === "") {
        throw new Error("Encoded string cannot be null or empty");
    }

    encoded = encoded.trim();

    if (encoded.length % 2 !== 0) {
        throw new Error("Invalid encoded string: length must be even");
    }

    let decoded = "";

    for (let i = 0; i < encoded.length; i += 2) {
        const segment = encoded.substring(i, i + 2);
        const val = parseInt(segment, 10);

        if (isNaN(val)) throw new Error(`Invalid segment: ${segment}`);

        if (val === 0) decoded += ".";
        else if (val >= 1 && val <= 26) decoded += String.fromCharCode(96 + val);
        else if (val === 27) decoded += "@";
        else if (val === 28) decoded += "-";
        else if (val === 29) decoded += "_";
        else if (val === 40) decoded += "+";
        else if (val >= 30 && val <= 39) decoded += String.fromCharCode(48 + (val - 30));
        else throw new Error(`Invalid code: ${segment}`);
    }

    return decoded;
};

export const isValidEmailStructure = (email) => {
    if (!email || email.trim() === "") return false;

    email = email.trim();

    if (!email.includes("@") || email.indexOf("@") !== email.lastIndexOf("@")) return false;
    if (email.startsWith("@") || email.endsWith("@")) return false;

    const [localPart, domain] = email.split("@");
    if (!localPart || !domain || !domain.includes(".") || domain.startsWith(".") || domain.endsWith(".")) {
        return false;
    }

    return true;
};
